let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ddgUA")).then(() => parcelRequire('gAQ8y'));